import { DecimalPipe } from '@angular/common';
import {
  VERTICAL_BAR_COLOR,
  DATAZOOM_FILLERCOLOR,
  LEGEND_COLOR,
  SPLITLINE_COLOR,
  STACKBAR_BG_COLOR,
  STACK_COLOR,
  XAXISLABEL_COLOR,
  YAXISLABEL_COLOR,
  HORIZONTAL_BAR_COLOR,
  DOUGHNUT_COLOR
} from '../constants';
import { BarChartOrientType, DataZoomOrientType, StackType } from '../models';

export class ChartOptions {
  /**
   * 绘制图形
   *
   * @param {*} chartId
   * @param {*} option
   * @memberof ChartOptions
   */
  // setChart(chartId, option): any {
  //   if (!Object.keys(option).length) return;
  //   let myChart = echarts.init(
  //     <HTMLDivElement>document.getElementById(chartId)
  //   );
  //   myChart.setOption(option);
  //   myChart.resize();
  //   return myChart;
  // }

  /**
   * 设置缩放区域
   *
   * @param {*} option
   * @param {string | number} startValue 缩放区域起始数值
   * @param {string | number} endValue 缩放区域结束数值
   * @param {DataZoomOrientType} orient 布局方式，默认为横向
   * @return {*}  {option}
   * @memberof ChartOptions
   */
  setDataZoom(
    option,
    startValue: string | number,
    endValue: string | number,
    orient: DataZoomOrientType = 'horizontal'
  ): Object {
    if (Object.keys(option).length) {
      option.dataZoom = {
        type: 'slider',
        orient: orient,
        startValue: startValue,
        endValue: endValue,
        maxValueSpan: 10, //限制窗口大小的最大类目
        fillerColor: DATAZOOM_FILLERCOLOR, //选中范围的填充颜色
        showDetail: false, //是否显示detail，即拖拽时候显示详细数值信息
        showDataShadow: false, //是否显示数据阴影
        zoomLock: true, //是否锁定选择区域的大小(设置为 true 则锁定，即只能平移，不能缩放)
        brushSelect: false, //是否开启刷选功能(按住鼠标左键后框选出选中部分)
      };
      if (orient === 'vertical') {
        option.dataZoom.width = 10;
      } else {
        option.dataZoom.height = 6;
      }
    }
    return option;
  }

  /**
   * 获取圆环图的 option 参数
   *
   * @param {string} graphicName graphic Name
   * @param {string} graphicValue graphic Value
   * @param {any[]} dataList
   * @param {string[]} colors
   * @return {*}  {option}
   * @memberof ChartOptions
   */
  getDoughnutChartOption(
    graphicName: string,
    graphicValue: string,
    dataList: any[],
    colors: string[]
  ): Object {
    let option = {
      color: colors,
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
      },
      legend: {
        left: 'center',
        top: "80%",
      },
      graphic: [
        {
          // 图形中间文字 Name
          type: 'text',
          left: 'center',
          top: '45%',
          style: {
            text: graphicName,
            textAlign: 'center',
            fill: 'rgba(255, 255, 255, 0.65)',
            fontSize: 16,
          },
        },
        {
          // 图形中间文字 Value
          type: 'text',
          left: 'center',
          top: '55%',
          style: {
            text: graphicValue,
            textAlign: 'center',
            fill: 'rgba(255, 255, 255, 0.90)',
            fontSize: 18,
          },
        },
      ],
      series: [
        {
          name: 'myChart',
          type: 'pie',
          label: {
            show: false,
          },
          emphasis: {
            scale: false,
          },
          data: dataList,
        },
      ],
    };
    return option;
  }

  /**
   * 获取直方图的 option 参数
   *
   * @param {string} axisName 坐标轴名称，与 orient 相关，默认为 y 轴名称
   * @param {Object[]} dataSource 数据集合(echarts 的 dataset.source)
   * @param {BarChartOrientType} orient 直方图显示方向，默认为纵向
   * @return {*}  {option}
   * @memberof ChartOptions
   */
  getBarChartOption(
    axisName: string,
    dataSource: Object[],
    orient: BarChartOrientType = 'vertical',
    en: boolean
  ): Object {
    let xAxisInfo = {
      type: 'category',
      axisTick: {
        show: false,
      },
      axisLabel: {//坐标轴刻度标签的相关设置。
        color: XAXISLABEL_COLOR,
        fontSize: 15,
        formatter: function (params) {
          var newParamsName = "";// 最终拼接成的字符串
          var paramsNameNumber = params.length;// 实际标签的个数
          var provideNumber = 10;// 每行能显示的字的个数
          if (en) {
            provideNumber = 15;
          }
          var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
          /**
           * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
           */
          // 条件等同于rowNumber>1
          if (paramsNameNumber > provideNumber) {
            /** 循环每一行,p表示行 */
            for (var p = 0; p < rowNumber; p++) {
              var tempStr = "";// 表示每一次截取的字符串
              var start = p * provideNumber;// 开始截取的位置
              var end = start + provideNumber;// 结束截取的位置
              // 此处特殊处理最后一行的索引值
              if (p == rowNumber - 1) {
                // 最后一次不换行
                tempStr = params.substring(start, paramsNameNumber);
              } else {
                // 每一次拼接字符串并换行
                tempStr = params.substring(start, end) + "\n";
              }
              newParamsName += tempStr;// 最终拼成的字符串
            }

          } else {
            // 将旧标签的值赋给新标签
            newParamsName = params;
          }
          //将最终的字符串返回
          return newParamsName
        },
      },

    };
    let yAxisInfo = {
      name: axisName,
      type: 'value',
      axisLabel: {
        color: YAXISLABEL_COLOR,
      },
      nameTextStyle: {
        color: YAXISLABEL_COLOR,
      },
      splitLine: {
        lineStyle: {
          color: SPLITLINE_COLOR,
        },
      },
    };
    let option = {
      toolbox: {
        show: true,
        feature: {
          dataZoom: {
            show: false
          },
          dataView: {
            show: false
          },
          magicType: {
            type: ["line", "bar"]
          },
          restore: { show: false },
          saveAsImage: {}
        }
      },
      color: '',
      dataset: {
        source: dataSource,
      },
      grid: {
        left: '2%',
        right: '10%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {},
      yAxis: {},
      series: [
        {
          type: 'bar',
          seriesLayoutBy: 'row',
          barWidth: 24,
          itemStyle: {
            normal: {
              label: {
                show: true, //开启显示
                position: 'right', //在上方显示
                textStyle: { //数值样式
                  color: 'black',
                  fontSize: 16
                }
              }
            }
          }
        },
      ],
      toolbar: {
        feature: {
          saveAsImage: true
        }
      }
    };
    if (orient === 'horizontal') {
      option.color = HORIZONTAL_BAR_COLOR;
      option.xAxis = yAxisInfo;
      option.yAxis = xAxisInfo;
      option.series[0].barWidth = 20;
    } else {
      option.color = VERTICAL_BAR_COLOR;
      option.xAxis = xAxisInfo;
      option.yAxis = yAxisInfo;
      option.series[0].barWidth = 24;
      option.series[0].itemStyle = {
        normal: {
          label: {
            show: true, //开启显示
            position: 'top', //在上方显示
            textStyle: { //数值样式
              color: 'black',
              fontSize: 16
            }
          }
        }
      }
    }
    return option;
  }

  /**
   * 获取堆叠直方/折线图的 option 参数
   *
   * @param {StackType} type 堆叠图的类型
   * @param {string} yAxisName y轴名称
   * @param {Object[]} dataSource 数据集合(echarts 的 dataset.source)
   * @return {*}  {option}
   * @memberof ChartOptions
   */
  getStackChartOption(
    type: StackType,
    yAxisName: string,
    dataSource: Object[]
  ): Object {
    let leng = dataSource.length;
    let stackSeries = [];
    if (leng > 1) {
      for (let index = 0; index < leng - 1; index++) {
        if (type === 'bar') {
          stackSeries.push({
            type: type,
            seriesLayoutBy: 'row',
            stack: 'stackName',
            barWidth: 24,
            showBackground: true,
            backgroundStyle: {
              color: STACKBAR_BG_COLOR,
            },
          });
        } else if (type === 'line') {
          stackSeries.push({
            type: type,
            seriesLayoutBy: 'row',
            stack: 'stackName',
            symbol: 'circle',
            symbolSize: 10,
            label: {
              show: true,
              position: 'top',
            },
            markLine: {
              symbol: "none",               //去掉警戒线最后面的箭头
              label: {
                position: "end",         //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                formatter: "98.5%",
              },
              data: [{
                silent: false,             //鼠标悬停事件  true没有，false有
                lineStyle: {               //警戒线的样式  ，虚实  颜色
                  type: "solid",
                  color: "rgba(238, 99, 99)"
                },
                yAxis: 98.5
              }]
            }
          });
        }
      }
    }
    let option = {
      color: STACK_COLOR,
      dataset: {
        source: dataSource,
      },
      xAxis: {
        type: 'category',
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: XAXISLABEL_COLOR,
        },
      },
      yAxis: {
        type: 'value',
        name: yAxisName,
        axisLabel: {
          color: YAXISLABEL_COLOR,
          formatter: '{value}%'
        },
        nameTextStyle: {
          color: YAXISLABEL_COLOR,
        },
        splitLine: {
          lineStyle: {
            color: SPLITLINE_COLOR,
          },
        },
        min: 93,
        max: 100,
      },
      series: stackSeries,
    };
    return option;
  }
  //由于WMSM不同折线图的目标值不同，为了不影响原来代码，单独写一个方法forWMSM折线图，传一个目标值参数
  getStackChartOptionforWMSM(
    type: StackType,
    yAxisName: string,
    dataSource: Object[],
    targetline: string,
    min: any,
  ): Object {
    let leng = dataSource.length;
    let stackSeries = [];
    if (leng > 1) {
      for (let index = 0; index < leng - 1; index++) {
        if (type === 'bar') {
          stackSeries.push({
            type: type,
            seriesLayoutBy: 'row',
            stack: 'stackName',
            barWidth: 24,
            showBackground: true,
            backgroundStyle: {
              color: STACKBAR_BG_COLOR,
            },
          });
        } else if (type === 'line') {
          stackSeries.push({
            type: type,
            seriesLayoutBy: 'row',
            stack: 'stackName',
            symbol: 'circle',
            symbolSize: 10,
            label: {
              show: true,
              position: 'top',
              formatter: function (params) {
                var number;
                number = params.data[1];
                return number + '%'
              }
            },
            markLine: {
              symbol: "none",               //去掉警戒线最后面的箭头
              label: {
                position: "end",         //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                formatter: targetline,
              },
              data: [{
                silent: false,             //鼠标悬停事件  true没有，false有
                lineStyle: {               //警戒线的样式  ，虚实  颜色
                  type: "solid",
                  color: "rgba(238, 99, 99)"
                },
                yAxis: 98.5
              }]
            }
          });
        }
      }
    }
    let option = {
      toolbox: {
        show: true,
        feature: {
          dataZoom: {
            show: false
          },
          dataView: {
            show: false
          },
          magicType: {
            type: ["line", "bar"]
          },
          restore: { show: false },
          saveAsImage: {}
        }
      },
      color: STACK_COLOR,
      dataset: {
        source: dataSource,
      },
      xAxis: {
        type: 'category',
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: XAXISLABEL_COLOR,
        },
      },
      yAxis: {
        type: 'value',
        name: yAxisName,
        axisLabel: {
          color: YAXISLABEL_COLOR,
          formatter: '{value}%'
        },
        nameTextStyle: {
          color: YAXISLABEL_COLOR,
        },
        splitLine: {
          lineStyle: {
            color: SPLITLINE_COLOR,
          },
        },
        min: min,
        max: 100,
      },
      series: stackSeries,
    };
    return option;
  }
  getDoughnutChartOptionForWMSM(
    dataList: any[],
  ): Object {
    let option = {
      color: DOUGHNUT_COLOR,
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
      },
      legend: {
        left: 'center',
        top: "5%",
      },
      series: [
        {
          name: 'myChart',
          type: 'pie',
          label: {
            show: false,
          },
          emphasis: {
            scale: false,
          },
          data: dataList,
        },
      ],
    };
    return option;
  }
  // setChartForWMSM(chartId, option) {
  //   if (!Object.keys(option).length) return;
  //   let myChart = echarts.init(
  //     <HTMLDivElement>document.getElementById(chartId)
  //   );
  //   myChart.setOption(option);
  //   myChart.on('click', function (param) {
  //     //param.name x轴值,param.data y轴值
  //     alert(param.name + ":" + param.value)

  //   });

  //   myChart.resize();
  // }

  // getDeliveryAnalysisReportWMSM(xdata): Object 
  // {
  //   const colors = ['#5470C6', '#91CC75', '#EE6666'];
  //   let option = {
  //     color: colors,
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: {
  //         type: 'cross'
  //       }
  //     },
  //     grid: {
  //       right: '20%'
  //     },
  //     toolbox: {
  //       feature: {
  //         dataView: { show: true, readOnly: false },
  //         restore: { show: true },
  //         saveAsImage: { show: true }
  //       }
  //     },
  //     xAxis: [
  //       {
  //         type: 'category',
  //         axisTick: {
  //           alignWithLabel: true
  //         },
  //         // prettier-ignore
  //         data: ['Jan', 'Feb']
  //       }
  //     ],
  //     yAxis: [
  //       {
  //       },
  //       {
  //       },
  //       {
  //         type: 'value',
  //         name: '百分比',
  //         position: 'left',
  //         alignTicks: true,
  //         axisLabel: {
  //           formatter: '{value} %'
  //         }
  //       }
  //     ],
  //     series: [
  //       {
  //         name: '廠區供應商的日交期維護率',
  //         type: 'bar',
  //         data1: [ 2.0, 4.9]
  //       }
  //       // ,
  //       // {
  //       //   name: 'WWW供應商的日交期維護率',
  //       //   type: 'line',
  //       //   yAxisIndex: 1,
  //       //   data2: [0.1,0.32]
  //       // },    {
  //       //   name: '廠區供應商30日內交期維護率',
  //       //   type: 'line',
  //       //   yAxisIndex: 2,
  //       //   color:'#EE6666',
  //       //   data3: [0.1,0.32]
  //       // }
  //     ]
  //   };
  //   return option;
  // }


  getDeliveryAnalysisReportWMSM(xdate, rate,
    WWCumulativeRate,
    CumulativeRate): Object {
    const colors = ['#5470C6', '#91CC75', '#EE6666'];
    let option = {
      color: colors,

      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        right: '20%'
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      legend: {
        data: ['Evaporation']
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          // prettier-ignore
          data: xdate
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '百分比',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      series: [
        {
          label: {
            show: true, //开启显示数值
            position: 'top', //数值在上方显示
            textStyle: {  //数值样式
              fontSize: 14  //字体大小},
            }
          },
          name: '廠區供應商的日交期維護率',
          type: 'bar',
          data: rate
        },
        {
          name: 'WW供應商的日交期維護率',
          type: 'line',
          data: WWCumulativeRate
        }, {
          name: '廠區供應商30日內交期維護率',
          type: 'line',
          color: '#EE6666',
          data: CumulativeRate
        }
      ]
    };
    return option;
  }

  //初始化图表
  getProcurementCostControlKanban1(YTMTypeDistXdata): Object {

    let option = {
      title: {
        text: '圖1.WT YTM的採購交易金額類別分布(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      grid: {
        left: '19%'
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      xAxis: [
        {
          type: 'category',
          data: ['設備類', '治具類', '配件類', '總務類', '工程類', '耗材類', '軟體類', '其它類'],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} '
          }
        },
      ],
      series: [
        {
          name: '金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value as number + ' K';
            }
          },
          data: YTMTypeDistXdata
        },
      ]
    };
    return option;


  }

  getProcurementCostControlKanban2(YearOnYearamount,
    YearOnYearamount2,): Object {
    let option = {
      title: {
        text: '圖2.WT 當年與前一年採購交易金額同比(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['2021','2022']
      },
      xAxis: [
        {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '2021',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YearOnYearamount
        },
        {
          name: '2022',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YearOnYearamount2
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanban3(top10vendorName, top10amount): Object {
    let option = {
      title: {
        text: '圖3.WT YTM的前10大採購交易金額供應商(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      legend: {},
      grid: {
        left: '2%',
        right: '14%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        name: '金额 K',// 这个设置只在末尾添加单位
        axisLabel: {
          formatter: `{value}K` // 在每个x轴坐标都添加了单位
        },
        type: 'value',
        boundaryGap: [0, 0.01],

      },
      yAxis: {
        type: 'category',
        name: '供应商',
        data: top10vendorName,
        axisLabel: {
          formatter: function (val) {
            if (val.length > 10) {
              return val.substring(0, 6) + '…';
            } else {
              return val;
            }
          }
        }
      },
      series: [
        {
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: top10amount
        }
      ]
    };
    return option;
  }

  getProcurementCostControlKanban4(YTMBmonth,
    YTMBpurchaseAmount, YTMBsaveAmount,): Object {
    let option = {
      title: {
        text: '圖4.WT YTM 的B類可控採購交易金額與節約金額(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: YTMBmonth,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YTMBpurchaseAmount
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YTMBsaveAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanban5(WTSite,
    purchaseAmount,
    saveAmount): Object {
    let option = {
      title: {
        text: '圖5.WT廠區在當月的B類可控採購交易金額與節約金額(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: WTSite,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: purchaseAmount
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: saveAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanban6(WTBeforeYearmonth, WTNowYearmonth): Object {
    let option = {
      title: {
        text: '圖6.WT 當年與前一年B類可控採購節約百分比同比(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      legend: {
        data: []
      },
      xAxis: [
        {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '百分比',
          max: 250,
          interval: 50,
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      series: [
        {
          name: '2021',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' %';
            }
          },
          data: WTBeforeYearmonth
        },
        {
          name: '2022',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' %';
            }
          },
          data: WTNowYearmonth
        },

      ]
    };
    return option;
  }


  //选择条件柱形图
  getProcurementCostControlKanbanSite(Xsite, SiteAmount): Object {
    let option = {
      title: {
        text: '圖1.厂区采购交易金额NTD计'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        data: []
      },
      xAxis: [
        {
          type: 'category',
          data: Xsite,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: SiteAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanbanMROType(TypeAmount, XType): Object {
    let option = {
      title: {
        text: '圖4.八大类别采购交易金额NTD计'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        data: []
      },
      xAxis: [
        {
          type: 'category',
          data: XType,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: TypeAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanbanYearOrMonth(XYearAndMouth, YearAndMouthAmount): Object {
    let option = {
      title: {
        text: '圖3.每月采购交易金额NTD计'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        data: []
      },
      xAxis: [
        {
          name: '月',// 这个设置只在末尾添加单位
          axisLabel: {
            formatter: `{value}月` // 在每个x轴坐标都添加了单位
          },
          type: 'category',
          data: XYearAndMouth,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YearAndMouthAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanbanBuyer(BuyerAmount, XBuyer): Object {
    let option = {
      title: {
        text: '圖2.采购名下采购交易金额NTD计'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        data: []
      },
      xAxis: [
        {
          type: 'category',
          data: XBuyer,
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            rotate: 45
          }

        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: BuyerAmount
        },

      ]
    };
    return option;
  }

  //课级初始化柱形图
  getProcurementCostControlKanbanSiteYTM(SiteYTBmonth,
    SiteYTMBpurchaseAmount, SiteYTMBsaveAmount,): Object {
    let option = {
      title: {
        text: '图1.廠區 YTM 的B類可控採購交易金額與節約金額(NTD$)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: SiteYTBmonth,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: SiteYTMBpurchaseAmount
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: SiteYTMBsaveAmount
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanbanSiteTop10(SiteTop10vendorName, SiteTop10amount): Object {
    let option = {
      title: {
        text: '图2.廠區前10大採購交易金額供應商(NTD$)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '14%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        name: '金额 K',// 这个设置只在末尾添加单位
        axisLabel: {
          formatter: `{value}K` // 在每个x轴坐标都添加了单位
        },
        type: 'value',
        boundaryGap: [0, 0.01],

      },
      yAxis: {
        type: 'category',
        name: '供应商',
        data: SiteTop10vendorName,
        axisLabel: {
          formatter: function (val) {
            if (val.length > 10) {
              return val.substring(0, 4) + '…';
            } else {
              return val;
            }
          }
        }
      },
      series: [
        {
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: SiteTop10amount
        }
      ]
    };
    return option;
  }

  chartbuyerName(monthbuyerName, monthbuyeramount, monthbuyersaveAmount) {
    let option = {
      title: {
        text: '图3.課單位採購員當月的B類可控採購交易與節約金額(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: monthbuyerName,
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: monthbuyeramount,
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: monthbuyersaveAmount,
        },

      ]
    };
    return option;
  }

  chartYTMbuyerName(YTMbuyerName, YTMbuyeramount, YTMbuyersaveAmount) {
    let option = {
      title: {
        text: '图4.課單位採購員YTM的B類可控採購交易與節約金額(NTD$)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: YTMbuyerName,
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            // 标签的显示间隔，0为强制显示全部，n为隔n标签显示一个标签
            interval: 0
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          position: 'left',
          alignTicks: true,
          axisLabel: {
            formatter: '{value} K'
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YTMbuyeramount,
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: YTMbuyersaveAmount,
        },

      ]
    };
    return option;
  }

  getProcurementCostControlKanbanSiteAmountMonth(YTMTypeDistXdata): Object {

    let option = {
      title: {
        text: '图5廠區當月採購交易金額類別分布(NTD$計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      grid: {
        left: '19%'
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      xAxis: [
        {
          type: 'category',
          data: ['設備類', '治具類', '配件類', '總務類', '工程類', '耗材類', '軟體類', '其它類'],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} '
          }
        },
      ],
      series: [
        {
          name: '金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value as number + ' K';
            }
          },
          data: YTMTypeDistXdata
        },
      ]
    };
    return option;


  }


  //采购初始化柱形图

  getProcurementCostControlKanbanMonthTop10(MonthTop10vendorName, MonthTop10amount): Object {
    let option = {
      title: {
        text: '图1.採購員當月的B類可控採購交易與節約金額類別(NTD計)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],

      },
      yAxis: {
        type: 'category',
        name: '供应商',
        data: MonthTop10vendorName,
        axisLabel: {
          formatter: function (val) {
            if (val.length > 10) {
              return val.substring(0, 4) + '…';
            } else {
              return val;
            }
          }
        }
      },
      series: [
        {
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value + ' K';
            }
          },
          data: MonthTop10amount
        }
      ]
    };
    return option;
  }


  chartbuyerB(Bxdata,
    BMonthamount,
    BMonthsaveAmount,): Object {
    let option = {
      title: {
        text: '图2.採購員的當月前10大採購交易金額供應商(NTD$)'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '19%'
      },
      legend: {
        top:'8%',
        data: ['采购交易金额','采购节约金额']
      },
      xAxis: [
        {
          type: 'category',
          data: ['設備類', '治具類', '配件類', '總務類', '工程類', '耗材類', '軟體類', '其它類'],
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '金额 K',
          axisLabel: {
            formatter: '{value} '
          }
        }
      ],
      series: [
        {
          name: '采购交易金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value;
            }
          },
          data: BMonthamount
        },
        {
          name: '采购节约金额',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value;
            }
          },
          data: BMonthsaveAmount
        },

      ]
    };
    return option;
  }



}








